document.addEventListener('DOMContentLoaded', function(){
    function clickButtons() {
        // Get the container element safely
        let container = document.querySelector('.collection-sidebar .boost-pfs-filter-tree-content .boost-pfs-filter-options-wrapper');
    
        // Check if the container exists
        if (!container) {
            return; // Exit the function early if container doesn't exist
        }
    
        // Query the buttons within the container
        let buttons = container.querySelectorAll('.boost-pfs-filter-option-title-heading');
    
        // Check if buttons are present
        if (buttons.length > 0) {
            buttons.forEach(function (button) {
                // Check if the button is visible
                if (button.offsetParent !== null) {
                    button.click(); // Perform the click action
                    clearInterval(intervalId); // Clear the interval
                }
            });
        }
    }
    
        const intervalId = setInterval(clickButtons, 200);
    
        setTimeout(function () {
            clearInterval(intervalId);
        }, 5000);

        let outerContainer = document.querySelector('.custom-collection-products');
        let leftControls, rightControls, productContainer, sliderProducts, productWidth, containerWidth, productsToShow, totalProducts, currentOffset, remainingProducts, previousProducts;

        if (outerContainer) {
            leftControls = outerContainer.querySelector('.slider-controls.control-left');
            rightControls = outerContainer.querySelector('.slider-controls.control-right');
            productContainer = outerContainer.querySelector('.slider-content');
            if (productContainer) {
                sliderProducts = productContainer.querySelectorAll('.grid__item');
                if (sliderProducts.length > 0) {
                    productWidth = sliderProducts[0].getBoundingClientRect().width;  // Use exact width
                    containerWidth = productContainer.offsetWidth;
                    productsToShow = Math.floor(containerWidth / productWidth);  // Calculate how many products fit fully
                    totalProducts = sliderProducts.length;
                    currentOffset = 0;
                    remainingProducts = totalProducts - productsToShow;
                    previousProducts = 0;

                    function slideProducts(slideCount) {
                        currentOffset += slideCount * productWidth;

                        sliderProducts.forEach((product) => {
                            product.style.transform = `translateX(${currentOffset}px)`;
                        });
                    }

                    if (rightControls) {
                        rightControls.addEventListener('click', () => {
                            if (remainingProducts > 0) {
                                let productsToSlide = Math.min(productsToShow, remainingProducts);
                                slideProducts(-productsToSlide);
                                previousProducts += productsToSlide;
                                remainingProducts -= productsToSlide;
                            }
                        });
                    }

                    if (leftControls) {
                        leftControls.addEventListener('click', () => {
                            if (previousProducts > 0) {
                                let productsToSlide = Math.min(productsToShow, previousProducts);
                                slideProducts(productsToSlide);
                                previousProducts -= productsToSlide;
                                remainingProducts += productsToSlide;
                            }
                        });
                    }
                }
            }
        }

        let recommendedOuterContainer = document.querySelector('.recommended-custom-collection-products');
        let recommendedLeftControls, recommendedRightControls, recommendedProductContainer, recommendedSliderProducts, recommendedProductWidth, recommendedContainerWidth, recommendedProductsToShow, recommendedTotalProducts, recommendedCurrentOffset, recommendedRemainingProducts, recommendedPreviousProducts;

        if (recommendedOuterContainer) {
            recommendedLeftControls = recommendedOuterContainer.querySelector('.recommended-slider-controls.recommended-control-left');
            recommendedRightControls = recommendedOuterContainer.querySelector('.recommended-slider-controls.recommended-control-right');
            recommendedProductContainer = recommendedOuterContainer.querySelector('.recommended-slider-content');
            if (recommendedProductContainer) {
                recommendedSliderProducts = recommendedProductContainer.querySelectorAll('.grid__item');
                if (recommendedSliderProducts.length > 0) {
                    recommendedProductWidth = recommendedSliderProducts[0].getBoundingClientRect().width;  // Use exact width
                    recommendedContainerWidth = recommendedProductContainer.offsetWidth;
                    recommendedProductsToShow = Math.floor(recommendedContainerWidth / recommendedProductWidth);  // Calculate how many products fit fully
                    recommendedTotalProducts = recommendedSliderProducts.length;
                    recommendedCurrentOffset = 0;
                    recommendedRemainingProducts = recommendedTotalProducts - recommendedProductsToShow;
                    recommendedPreviousProducts = 0;

                    function recommendedSlideProducts(recommendedSlideCount) {
                        recommendedCurrentOffset += recommendedSlideCount * recommendedProductWidth;

                        recommendedSliderProducts.forEach((recommededProduct) => {
                            recommededProduct.style.transform = `translateX(${recommendedCurrentOffset}px)`;
                        });
                    }

                    if (recommendedRightControls) {
                        recommendedRightControls.addEventListener('click', () => {
                            if (recommendedRemainingProducts > 0) {
                                let recommendedProductsToSlide = Math.min(recommendedProductsToShow, recommendedRemainingProducts);
                                recommendedSlideProducts(-recommendedProductsToSlide);
                                recommendedPreviousProducts += recommendedProductsToSlide;
                                recommendedRemainingProducts -= recommendedProductsToSlide;
                            }
                        });
                    }

                    if (recommendedLeftControls) {
                        recommendedLeftControls.addEventListener('click', () => {
                            if (recommendedPreviousProducts > 0) {
                                let recommendedProductsToSlide = Math.min(recommendedProductsToShow, recommendedPreviousProducts);
                                recommendedSlideProducts(recommendedProductsToSlide);
                                recommendedPreviousProducts -= recommendedProductsToSlide;
                                recommendedRemainingProducts += recommendedProductsToSlide;
                            }
                        });
                    }
                }
            }
        }

        // Dynamic mobile add to cart button
        let header = document.querySelector('.header-sticky-wrapper');
        let toolBar = document.querySelector('.toolbar__content');
        let headerHeight = header ? header.getBoundingClientRect().height : 0;
        let toolBarHeight = toolBar ? toolBar.getBoundingClientRect().height : 0;
        let dynamicBtnContainer = document.querySelector('.mobile-cta-sticky');
        if (dynamicBtnContainer) {
            window.addEventListener('scroll', function() {
                let scrolledDistance = window.scrollY;

                if (scrolledDistance >= (headerHeight + toolBarHeight)) {
                    dynamicBtnContainer.style.top = `${headerHeight - 1}px`;
                } else {
                    dynamicBtnContainer.style.top = `${headerHeight + toolBarHeight - 1}px`;
                }
            });
        }


    setTimeout(function() {
        // Function regarding size guides
        let sizeButton = document.querySelector('.size-guide');
        if (sizeButton) {
            sizeButton.addEventListener('click', function() {
                let tabs = document.querySelectorAll('#tiny-tabs-wrapper .tiny-tabs-title');
                let header = document.querySelector('#SiteHeader');
                let headerHeight = header ? header.getBoundingClientRect().height : 0;
                let found = false;
                tabs.forEach(function(tab) {
                    let tabContent = tab.textContent.trim();
                    if (tabContent === 'Størrelsesguide' || tabContent === 'Storleksguide' || tabContent === 'Sizeguide') {
                        // Get the tab's position relative to the viewport
                        let tabPosition = tab.getBoundingClientRect().top;

                        // Calculate the scroll position, subtracting the header height
                        let scrollPosition = window.scrollY + tabPosition - headerHeight;

                        // Smoothly scroll to the calculated position
                        window.scrollTo({
                            top: scrollPosition,
                            behavior: 'smooth'
                        });

                        // Perform your desired action, e.g., click the tab
                        tab.click();
                        found = true;
                    }
                });
                // Fallback: hide sizeButton if no tab was found
                if (!found) {
                    sizeButton.style.display = 'none';
                }
            });
        }
    }, 400);

});